import { generateMessage } from '@/utils/i18n';
import { mapState } from 'vuex';

const sortable = {
  computed: {
    ...mapState({
      sort(state, getters) {
        return getters[`${this.namespace}/sort`];
      },
    }),
    sortBy: {
      get() {
        return this.$store.getters[`${this.namespace}/sortBy`] || [];
      },
      set(val) {
        this.handleSortByChange(val);
      },
    },
    sortDESC: {
      get() {
        return (
          this.$store.getters[`${this.namespace}/sortASC`].map((el) => !el) ||
          []
        );
      },
      set(val) {
        this.handleSortASCChange(val);
      },
    },
  },
  methods: {
    generateMessage,
    toogleOrderASC() {
      this.$store.dispatch(`${this.namespace}/toogleOrderASC`);
    },
    handleSortByChange(val) {
      if (val !== this.sortBy) {
        this.$store.dispatch(`${this.namespace}/setItemsSortBy`, val);
      }
    },
    handleSortASCChange(val) {
      if (val !== this.sortDESC) {
        this.$store.dispatch(
          `${this.namespace}/setOrderASC`,
          val.map((el) => !el)
        );
      }
    },
    getFirstEl(val) {
      if (Array.isArray(val) && val.length) {
        return val[0];
      }
      if (typeof val === 'string' && val.length) {
        return val;
      }
      return null;
    },
  },
};

export default sortable;
